import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-walking-japanese-v2',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['japanese_walking'],
	},
	landing: {
		ids: ['loader-walking-japanese-f-v2', 'age-walking-japanese-f-v2'],
		route: {
			path: '/walking-japanese-f-v2',
			name: 'walking-japanese-funnel-v2',
		},
	},
	funnel: {
		id: 'ob-female-activity-walking-japanese-v2',
		route: {
			path: '/walking-japanese-f-v2/ob/:page*',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-activity-walking-japanese-v2',
		},
		slug: 'activity-female-walking-japanese-v2',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-walking-japanese-f',
		overrides: [],
	},
	upsell: {
		routeNames: ['upsell-activity-f'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
